import { parseIframeEmbedCode } from './embedCode';
import excel from './excel.png';
import type { EmbedProviderConfig } from './embed';

export const microsoftExcelEmbedConfig: EmbedProviderConfig = {
  providerName: 'Microsoft',
  titleKey: 'document.grid.embed.dialog_title_excel',
  step1InstructionsKey: 'document.grid.embed.dialog_step_1_instructions_excel',
  descriptionKey: 'document.grid.embed.dialog_description_excel',
  inputLabelKey: 'document.grid.embed.dialog_input_label_excel',
  docsUrl:
    'https://support.microsoft.com/en-us/office/share-it-embed-an-excel-workbook-on-your-web-page-or-blog-from-onedrive-804e1845-5662-487e-9b38-f96307144081',
  image: excel,
  parser: parseIframeEmbedCode,
  // The Office Online viewer needs its own origin's storage/cookies (allow-same-origin) and allow-forms
  // to bootstrap - without them it silently renders blank. Empirically confirmed: allow-scripts alone
  // (the IFrame component's default) leaves it blank.
  sandbox: 'allow-scripts allow-same-origin allow-forms',
};
